import React, { Fragment, useState, useEffect } from "react";
import AntTable from "../../common/Table"; 
import { compose, graphql } from 'react-apollo';
import { removeRoomM } from "../../../graphql/mutation/room";
import columns from "../../../const/columns/rooms";
import { openNotificationWithIcon } from "../../common/Notification";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { Spin } from "antd";

function Rooms({props, removeRoom}){
    let [ rooms, setRoms ] = useState([]);
    let [ loading, setLoading ] = useState(false); 
 
    async function deleteF(id){
        let body = {
            _id: id,
            removeRoom 
        };
    
        await props.REMOVE_ROOM(body);

        setTimeout(() => {props.refetch()},10)
        openNotificationWithIcon('success', "Sucesso", "Sala deletada com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }

    function refresh(){
        setLoading(loading = true);
        setTimeout(() => {
            setLoading(loading = false);
            props.refetch();
        }, 1000);
    }

    function getRooms(){
        let roomsDB = [];

        props.rooms.map(room => {
            roomsDB.push({   
                _id: room._id,
                name: room.name,
                link: room.link,
                branch: room.branch_info[0].name
            });
            return null
        })
        
        if(roomsDB.length > 0) setRoms(rooms = roomsDB);
    }

    useEffect(() => {
        getRooms()
    }, [props.rooms]);
    
    return(
        <Fragment> 
            <RefreshButton clickAction={refresh}/>
            <Spin spinning={loading}>
                <AntTable 
                    dataSource={rooms} 
                    columns={columns} 
                    new={routes.ROOMS_NEW} 
                    delete={deleteF} 
                    update={update}
                    btEdit={true}
                    hideBtnNew={false}
                />
            </Spin>
        </Fragment>
    )
}

export default compose(
    graphql( removeRoomM, { name: "removeRoom" } )
)(Rooms);


// WEBPACK FOOTER //
// ./src/components/general/roomsWrapper/Rooms.jsx